import document from '../globalWrappers/document';
import window from '../globalWrappers/window';

const showError = () => {
  let urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has('reval')) {
    let formContainer = document.getElementById('form-container');
    let errorElem = document.createElement('div');
    errorElem.style = 'color: rgb(211, 47, 47); margin-bottom: 20px; font-weight: 500;';
    errorElem.innerText = decodeURIComponent(urlParams.get('reval'));
    formContainer.prepend(errorElem);
  }
};

export default showError;